import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui';
import { IllustrationAccessDenied } from './ui';

export default function AccessDenied() {
  return (
    <div className="h-full flex items-center justify-center p-8">
      <div className="text-center max-w-sm w-full">

        <div className="mb-6 flex justify-center">
          <IllustrationAccessDenied width={200} />
        </div>

        <h1 className="text-lg font-semibold text-[var(--color-text-primary)] tracking-[-0.01em] mb-2">
          Access Restricted
        </h1>
        <p className="text-sm text-[var(--color-text-secondary)] leading-relaxed mb-8">
          You don't have permission to view this page. If you think you should have access,
          contact Sid at{' '}
          <a
            href="mailto:smpatil4@illinois.edu"
            className="text-[var(--color-orange)] hover:underline font-medium"
          >
            smpatil4@illinois.edu
          </a>
          .
        </p>

        <div className="flex items-center justify-center gap-3">
          <Link to="/">
            <Button variant="primary" mobileExpand>Go to Home</Button>
          </Link>
          <Link to="/profile">
            <Button variant="secondary" mobileExpand>View My Access</Button>
          </Link>
        </div>

      </div>
    </div>
  );
}